import * as Yup from 'yup';

import {  } from '../validations';

export const vatValidationSchema = Yup.object().shape({
});
